import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { defaultLoadingText, defaultUploadButtonText } from "../core/dropzone.strings.es.js";
import { DropzonePreviewer } from "./file-previewer.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { FontSize } from "../../../foundations/typography.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { memo } from "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { InboxUploadOutlined as i } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/inbox-upload-outlined.es.es.js";
import { UploadAltSolid as n } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/upload-alt-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Progress } from "../../progress/progress.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Typography } from "../../typography/typography.es.js";
import { Button } from "../../button/button.es.js";
const CustomDropzoneContainer = styled("div")(({
  theme
}) => {
  return {
    display: Displaying.flex,
    padding: `${theme.spacing(10)} 0px`,
    flexDirection: Direction.column,
    justifyContent: Alignment.center,
    alignItems: Alignment.center,
    gap: theme.spacing(8)
  };
});
const MemoizedLoadingPhase = memo(function LoadingPhase({
  children
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Progress, { variant: "indeterminate", value: 0, hideLabel: true, size: Spacing["2000"], color: "secondary" }),
    /* @__PURE__ */ jsx(Typography, { color: "textSecondary", fontSize: FontSize["xs"], children })
  ] });
});
const MemoizeDropPhase = memo(function DropPhase({
  children
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(n, { color: "primary", scale: Spacing["2000"] }),
    /* @__PURE__ */ jsx(Button, { color: "primary", variant: "outlined", size: "small", endIcon: /* @__PURE__ */ jsx(i, {}), children })
  ] });
});
function DropzoneContainer({
  uploadButtonText,
  isLoading,
  loadingText,
  acceptedFiles
}) {
  const hasFiles = acceptedFiles && acceptedFiles.length > 0;
  const showOnlyFilePreview = !isLoading && hasFiles;
  if (showOnlyFilePreview) {
    return /* @__PURE__ */ jsx(DropzonePreviewer, { acceptedFiles });
  }
  return /* @__PURE__ */ jsx(CustomDropzoneContainer, { children: isLoading ? /* @__PURE__ */ jsx(MemoizedLoadingPhase, { children: loadingText ?? defaultLoadingText }) : /* @__PURE__ */ jsx(MemoizeDropPhase, { children: uploadButtonText ?? defaultUploadButtonText }) });
}
export {
  DropzoneContainer
};
//# sourceMappingURL=main-container.es.js.map
